import PhoneNumberInput from "react-phone-number-input";

import "react-phone-number-input/style.css";
import CustomInput from "./CustomInput";

const PhoneInput = ({
  className,
  label,
  onChange,
  disabled,
  id,
  error,
  onClear,
  name,
  value,
  required,
}: {
  className?: string;
  label?: string;
  country?: string;
  onChange: Function;
  disabled?: boolean;
  id: string;
  error?: string;
  onClear?: any;
  name: string;
  value?: string;
  required?: boolean;
}) => {
  return (
    <CustomInput id={id} label={label} error={error} onClear={value && onClear}>
      <PhoneNumberInput
        placeholder="(###) ###-####"
        name={name}
        value={value}
        onChange={(value) =>
          onChange({ target: { value: value || "", id, name } })
        }
        defaultCountry="US"
        className={className}
        disabled={disabled}
        required={required}
        id={id}
        displayInitialValueAsLocalNumber
      />
    </CustomInput>
  );
};

export default PhoneInput;
